import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Plain text-only chip. Caller controls colour through the `badgeClass`
 * input (typically a per-surface taxonomy class — e.g. an AI-Act risk
 * level or a vendor type label). Status-bearing rows render via
 * `<app-status-indicator>`, not this component.
 */
@Component({
  selector: 'app-badge',
  imports: [CommonModule],
  template: `
    <span class="badge" [class]="badgeClass()">
      {{ text() }}
    </span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  /** CSS class applied alongside the base `.badge`. */
  badgeClass = input<string>('');
  /** Display text. */
  text = input<string>('');
}
